import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "Grandpiano",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "Grandpiano",
    description: "Grandpiano",
    image: require("./Grandpiano.svg"),
    svgIcon: require("./Grandpiano.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 50,
      max: 500,
      defaultValue: 300,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 50,
      max: 500,
      defaultValue: 300,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g transform={`translate(-19, 55) scale(1, -1)`}>
          <defs>
            <style>{`.cls-1{fill:#fff;}`}</style>
          </defs>
          <g id={`${element.type}-${element.id}`} data-name="corner shower">
            <path
              class="cls-1"
              d="M91.94,81.65a1.73,1.73,0,0,1,.31-.05c1,.12,1.14-.18,1.14-1.16,0-6.22,0-12.44,0-18.66A23.65,23.65,0,0,0,93,57.41,20.72,20.72,0,0,0,83.36,43.5a26.8,26.8,0,0,0-7-2.86,8.91,8.91,0,0,1-6.2-5.89,19.72,19.72,0,0,1-.62-5.35,26.86,26.86,0,0,0-2.63-10.15,27.46,27.46,0,0,0-9.5-11A28,28,0,0,0,41.11,3.36a28.19,28.19,0,0,0-24,14,28.36,28.36,0,0,0-3.74,14.41q.06,24.24,0,48.46c0,1-.3,1.43,1.27,1.42,0,0,.07,0,.11.06a.36.36,0,0,1,0,.11c0,.62,0,1.23,0,1.85,0,1.42,0,1.42,1.41,1.66v6c0,1.07,0,1.11,1.11,1.11H89.57c.87,0,1-.1,1-.94V85.25l.39,0c1,0,1-.09,1-1Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M91.94,81.65v2.54c0,.94,0,1-1,1l-.39,0v6.17c0,.84-.1.94-1,.94H17.3c-1.07,0-1.11,0-1.11-1.11v-6c-1.41-.24-1.41-.24-1.41-1.66,0-.62,0-1.23,0-1.85a.56.56,0,0,0,0-.12s-.07,0-.11,0c-1.57,0-1.27-.37-1.27-1.42q0-24.23,0-48.46a28.36,28.36,0,0,1,3.74-14.41,28.19,28.19,0,0,1,24-14A28,28,0,0,1,57.42,8.25a27.46,27.46,0,0,1,9.5,11A26.86,26.86,0,0,1,69.55,29.4a19.72,19.72,0,0,0,.62,5.35,8.91,8.91,0,0,0,6.2,5.89,26.8,26.8,0,0,1,7,2.86A20.72,20.72,0,0,1,93,57.41a23.65,23.65,0,0,1,.36,4.37c0,6.22,0,12.44,0,18.66,0,1-.18,1.28-1.14,1.16A1.73,1.73,0,0,0,91.94,81.65Zm-77.87-.81H92.66v-.78q0-9.14,0-18.27a24.73,24.73,0,0,0-.19-3.11c-.84-6.43-4.22-11.2-9.59-14.66A26.62,26.62,0,0,0,76,41.28a9.6,9.6,0,0,1-6-5A11.86,11.86,0,0,1,68.9,31a26.76,26.76,0,0,0-9.58-20.43A27.69,27.69,0,0,0,28.91,7.07a27.24,27.24,0,0,0-9.74,8.31,26.94,26.94,0,0,0-5.11,16.16q0,24.27,0,48.52Zm75.7,4.76H17v6H89.77Zm-48.13-4H15.55v2.85H91.17V81.63H65.08v.6c0,1.07,0,1.07-1.1,1.07H42.78c-1.13,0-1.13,0-1.14-1.1Zm.56,1.09H64.52v-.94H42.2Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              class="cls-1"
              d="M14.07,80.84v-.78q0-24.26,0-48.52a26.94,26.94,0,0,1,5.11-16.16A27.57,27.57,0,0,1,44.27,4.2a27.1,27.1,0,0,1,15,6.38A26.76,26.76,0,0,1,68.9,31,11.86,11.86,0,0,0,70,36.31a9.6,9.6,0,0,0,6,5A26.62,26.62,0,0,1,82.87,44c5.37,3.46,8.75,8.23,9.59,14.66a24.73,24.73,0,0,1,.19,3.11q0,9.13,0,18.27v.78Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              class="cls-1"
              d="M89.77,85.6v6H17v-6Zm-16,3.6.2-.11c0-1,0-2,0-3,0-.13-.24-.26-.37-.39l-.16.13c0,1,0,2,0,3C73.44,88.92,73.65,89.06,73.76,89.2Zm11.41-3.43L85,85.65c-.12.14-.34.28-.34.42,0,.92,0,1.83,0,2.74,0,.11.17.22.26.33.09-.11.26-.22.26-.33C85.18,87.8,85.17,86.78,85.17,85.77Zm-2.06,0L83,85.66c-.13.13-.36.26-.36.39,0,.91,0,1.83,0,2.74,0,.45.23.4.52.27ZM77,85.65l-.17.15v3.29l.14.11c.12-.12.33-.24.33-.36,0-.93,0-1.87,0-2.8C77.3,85.91,77.11,85.78,77,85.65Zm1.68,1.78c0-.46,0-.93,0-1.39,0-.11-.17-.22-.27-.32-.08.09-.24.18-.24.28q0,1.43,0,2.85c0,.1.15.19.23.29.1-.1.27-.2.28-.31C78.7,88.36,78.68,87.9,78.68,87.43Zm1.28,0c0-.42,0-.84,0-1.26,0-.15-.16-.28-.25-.41-.09.12-.27.25-.27.38,0,.88,0,1.77,0,2.66,0,.13.18.25.28.38.08-.14.23-.27.24-.41C80,88.28,80,87.84,80,87.39Zm1.29,1.69.16.12c.12-.11.34-.23.35-.35,0-1,0-2.06,0-3.1l-.19-.1c-.11.13-.31.25-.31.39C81.24,87.05,81.25,88.06,81.25,89.08Zm4.75,0,.15.11c.11-.13.32-.26.33-.4q0-1.37,0-2.73c0-.14-.23-.27-.35-.4l-.13.13Zm1.27,0,.15.11c.12-.13.33-.26.33-.4q0-1.37,0-2.73c0-.14-.23-.27-.35-.4l-.13.13Zm-68.14-1.7c0-.46,0-.93,0-1.39,0-.1-.16-.18-.25-.27-.09.08-.25.17-.25.26,0,1,0,1.9,0,2.86,0,.1.18.2.28.3.08-.1.22-.19.23-.3C19.15,88.36,19.14,87.87,19.13,87.38Zm1.36-1.6-.18-.12c-.11.14-.32.27-.33.41,0,.91,0,1.82,0,2.73,0,.12.16.23.25.34.08-.11.25-.21.25-.33C20.5,87.8,20.49,86.79,20.49,85.78Zm2,0-.17-.12c-.12.13-.34.27-.34.4,0,.91,0,1.83,0,2.74,0,.11.16.23.24.34.1-.1.27-.21.27-.32C22.54,87.81,22.53,86.8,22.53,85.78Zm.79,1.61c0,.46,0,.93,0,1.39,0,.13.16.24.24.36.1-.1.27-.2.28-.31q0-1.39,0-2.79c0-.11-.18-.22-.27-.32-.08.11-.24.22-.24.34C23.31,86.5,23.32,86.94,23.32,87.39Zm1.82.06c0-.44,0-.89,0-1.33,0-.14-.17-.27-.25-.4-.1.12-.27.25-.27.38q0,1.34,0,2.67c0,.12.18.25.28.37.08-.12.23-.23.24-.36C25.15,88.34,25.14,87.9,25.14,87.45ZM27,85.82l-.21-.16c-.11.14-.31.28-.31.43q0,1.34,0,2.67c0,.13.17.25.26.38.09-.13.24-.27.24-.41C27,87.76,27,86.79,27,85.82Zm1.32,1.55c0-.44,0-.89,0-1.33,0-.11-.17-.22-.26-.32-.09.11-.25.22-.25.33q0,1.36,0,2.73c0,.12.15.24.23.36.1-.12.27-.24.28-.37C28.33,88.31,28.31,87.84,28.31,87.37Zm2,.07c0-.47,0-.94,0-1.4,0-.11-.17-.22-.26-.32-.09.09-.24.18-.24.27,0,1,0,1.9,0,2.86,0,.1.15.19.23.29.1-.1.27-.2.28-.31C30.36,88.37,30.34,87.9,30.34,87.44ZM31.7,85.8l-.2-.16c-.11.14-.31.27-.31.4q0,1.36,0,2.73c0,.13.18.25.28.37.08-.12.22-.24.22-.36C31.71,87.79,31.7,86.79,31.7,85.8Zm1.28,0-.2-.15c-.11.14-.31.28-.32.43,0,.89,0,1.78,0,2.67,0,.13.17.25.27.38.08-.13.23-.27.24-.41C33,87.76,33,86.79,33,85.81Zm1.5-.17-.21.15c0,1,0,2,0,3,0,.13.18.25.27.37.08-.12.23-.24.23-.36,0-.91,0-1.82,0-2.73C34.78,85.91,34.58,85.78,34.48,85.64Zm1.68.18L36,85.65c-.11.13-.32.25-.33.38,0,.93,0,1.86,0,2.79,0,.11.17.21.26.32.09-.11.24-.23.24-.34C36.16,87.8,36.16,86.81,36.16,85.82Zm2,0L38,85.66c-.12.14-.32.28-.32.42,0,.89,0,1.78,0,2.67,0,.13.17.26.26.39.09-.13.25-.27.25-.4C38.2,87.77,38.19,86.79,38.19,85.82Zm1.33,1.6c0-.44,0-.89,0-1.33,0-.13-.17-.25-.27-.37-.08.11-.23.23-.24.35,0,.9,0,1.82,0,2.72,0,.12.15.24.24.35.09-.13.25-.25.26-.38C39.54,88.31,39.52,87.87,39.52,87.42Zm1.27.06c0-.49,0-1,0-1.46,0-.11-.19-.2-.28-.3-.08.09-.23.19-.23.29q0,1.39,0,2.79c0,.12.16.23.25.34.09-.11.25-.21.26-.33C40.81,88.37,40.79,87.92,40.79,87.48Zm1.86,0c0-.47,0-.94,0-1.4,0-.13-.18-.25-.27-.37-.08.11-.24.23-.24.35q0,1.37,0,2.73c0,.11.16.23.25.34.09-.13.25-.25.26-.39C42.67,88.33,42.65,87.91,42.65,87.49Zm1-1.83-.18.12c0,1,0,2,0,3,0,.11.17.21.26.32.09-.11.24-.22.25-.34,0-.91,0-1.82,0-2.73C44,85.93,43.73,85.8,43.62,85.66Zm2.07,0-.22.15c0,1,0,2,0,3,0,.12.15.24.23.36.1-.12.28-.24.28-.37,0-.89,0-1.78,0-2.67C46,86,45.79,85.8,45.69,85.65Zm1.67,1.78c0-.46,0-.93,0-1.39,0-.12-.17-.22-.26-.32-.09.09-.24.18-.24.27,0,1,0,1.91,0,2.86,0,.1.15.19.23.29.09-.1.26-.2.27-.31C47.38,88.36,47.36,87.9,47.36,87.43Zm1.28-1.62-.21-.15c-.11.14-.3.29-.31.44,0,.89,0,1.78,0,2.67,0,.12.18.25.27.37.09-.12.23-.23.24-.35C48.65,87.79,48.64,86.8,48.64,85.81Zm1.46-.15-.17.12c0,1,0,2,0,3,0,.11.17.21.26.32.08-.11.24-.22.24-.34,0-.91,0-1.82,0-2.73C50.43,85.93,50.22,85.8,50.1,85.66Zm1.72,1.8c0-.46,0-.93,0-1.39,0-.13-.15-.24-.23-.35-.1.1-.27.2-.27.31q0,1.39,0,2.79c0,.11.17.21.26.32.09-.11.24-.23.24-.35C51.83,88.35,51.82,87.91,51.82,87.46Zm2-.07c0-.42,0-.85,0-1.27,0-.14-.16-.27-.25-.4-.09.12-.26.25-.26.38q0,1.34,0,2.67c0,.12.18.25.28.37.08-.12.22-.23.23-.36C53.87,88.32,53.85,87.85,53.85,87.39Zm1-1.73-.17.12c0,1,0,2,0,3,0,.11.17.21.26.32.08-.11.24-.23.24-.34,0-.91,0-1.82,0-2.73C55.15,85.93,54.94,85.8,54.82,85.66Zm1.28,0-.18.12c0,1,0,2,0,3,0,.11.17.22.26.33.09-.11.24-.22.25-.34,0-.91,0-1.82,0-2.73C56.43,85.93,56.22,85.8,56.1,85.66Zm2.2,1.79c0-.47,0-.93,0-1.4,0-.11-.16-.22-.25-.33-.09.1-.26.21-.26.32,0,.91,0,1.82,0,2.73,0,.12.18.25.28.37.08-.12.23-.24.23-.36C58.32,88.34,58.3,87.89,58.3,87.45Zm1-1.8-.17.17c0,1,0,2,0,3,0,.12.16.23.25.34.09-.11.25-.21.25-.33,0-.93,0-1.86,0-2.79C59.6,85.89,59.39,85.77,59.27,85.65Zm2.07,0-.17.16v3.28l.17.11c.11-.15.3-.29.31-.44,0-.88,0-1.77,0-2.66C61.64,86,61.45,85.8,61.34,85.65ZM63,87.45c0-.46,0-.93,0-1.39,0-.12-.16-.23-.24-.34-.1.1-.27.21-.27.32q0,1.39,0,2.79c0,.11.18.21.28.31.08-.12.22-.23.23-.36C63,88.34,63,87.9,63,87.45Zm1.28,0c0-.46,0-.93,0-1.39,0-.14-.18-.26-.27-.38-.09.11-.24.22-.24.34q0,1.36,0,2.73c0,.12.15.23.23.35.1-.12.26-.25.28-.38C64.32,88.34,64.3,87.92,64.3,87.49Zm1.31,1.56.19.15c.1-.15.29-.29.3-.44,0-.89,0-1.78,0-2.67,0-.42-.19-.45-.51-.29Zm1.87-1.62c0-.44,0-.89,0-1.33,0-.13-.17-.26-.27-.38-.08.11-.24.22-.24.34q0,1.36,0,2.73c0,.12.15.23.24.35.09-.12.26-.25.27-.38C67.5,88.32,67.48,87.87,67.48,87.43Zm2,0c0-.47,0-.93,0-1.4,0-.1-.15-.19-.23-.29-.1.1-.28.2-.28.3,0,.93,0,1.86,0,2.79,0,.11.17.22.27.33.08-.11.24-.22.25-.34C69.53,88.34,69.51,87.87,69.51,87.41Zm1-1.77-.22.14c0,1,0,2,0,3,0,.1.17.21.26.31.09-.11.24-.23.24-.35,0-.91,0-1.82,0-2.73C70.81,85.92,70.63,85.78,70.53,85.64Zm1.25,0-.16.15V89.1l.17.1c.11-.15.3-.29.3-.44q0-1.33,0-2.67C72.09,85.94,71.89,85.8,71.78,85.66Zm3.15,0-.13.12v3.34l.18.1c.1-.14.29-.28.29-.42q0-1.36,0-2.73C75.26,85.93,75.05,85.8,74.93,85.66Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              class="cls-1"
              d="M41.64,81.63v.57c0,1.1,0,1.1,1.14,1.1H64c1.1,0,1.1,0,1.1-1.07v-.6H91.17v2.85H15.55V81.63Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              class="cls-1"
              d="M42.2,82.72v-.94H64.52v.94Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M73.76,89.2c-.11-.14-.32-.28-.33-.43,0-1,0-2,0-3l.16-.13c.13.13.36.26.37.39,0,1,0,2,0,3Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M85.17,85.77c0,1,0,2,0,3,0,.11-.17.22-.26.33-.09-.11-.26-.22-.26-.33,0-.91,0-1.82,0-2.74,0-.14.22-.28.34-.42Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M83.11,85.79v3.27c-.29.13-.52.18-.52-.27,0-.91,0-1.83,0-2.74,0-.13.23-.26.36-.39Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M77,85.65c.11.13.3.26.31.39,0,.93,0,1.87,0,2.8,0,.12-.21.24-.33.36l-.14-.11V85.8Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M78.68,87.43c0,.47,0,.93,0,1.4,0,.11-.18.21-.28.31-.08-.1-.23-.19-.23-.29q0-1.42,0-2.85c0-.1.16-.19.24-.28.1.1.26.21.27.32C78.7,86.5,78.68,87,78.68,87.43Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M80,87.39c0,.45,0,.89,0,1.34,0,.14-.16.27-.24.41-.1-.13-.27-.25-.28-.38,0-.89,0-1.78,0-2.66,0-.13.18-.26.27-.38.09.13.24.26.25.41C80,86.55,80,87,80,87.39Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M81.25,89.08c0-1,0-2,0-3,0-.14.2-.26.31-.39l.19.1c0,1,0,2.07,0,3.1,0,.12-.23.24-.35.35Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M86,89.08V85.79l.13-.13c.12.13.34.26.35.4q0,1.36,0,2.73c0,.14-.22.27-.33.4Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M87.27,89.08V85.79l.13-.13c.12.13.35.26.35.4q0,1.36,0,2.73c0,.14-.21.27-.33.4Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M19.14,87.38c0,.49,0,1,0,1.46,0,.11-.15.2-.23.3-.1-.1-.28-.2-.28-.3,0-1,0-1.91,0-2.86,0-.09.16-.18.25-.26.09.09.25.17.25.27C19.15,86.45,19.13,86.92,19.14,87.38Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M20.49,85.78c0,1,0,2,0,3,0,.12-.17.22-.25.33-.09-.11-.25-.22-.25-.34,0-.91,0-1.82,0-2.73,0-.14.22-.27.33-.41Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M22.53,85.78c0,1,0,2,0,3,0,.11-.17.22-.27.32-.08-.11-.23-.23-.24-.34,0-.91,0-1.83,0-2.74,0-.13.22-.27.34-.4Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M23.32,87.39c0-.45,0-.89,0-1.33,0-.12.16-.23.24-.34.09.1.26.21.27.32q0,1.39,0,2.79c0,.11-.18.21-.28.31-.08-.12-.23-.23-.24-.36C23.31,88.32,23.32,87.85,23.32,87.39Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M25.14,87.45c0,.45,0,.89,0,1.33,0,.13-.16.24-.24.36-.1-.12-.28-.25-.28-.37q0-1.33,0-2.67c0-.13.17-.26.27-.38.08.13.24.26.25.4C25.16,86.56,25.14,87,25.14,87.45Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M27,85.82c0,1,0,1.94,0,2.91,0,.14-.15.28-.24.41-.09-.13-.26-.25-.26-.38q0-1.33,0-2.67c0-.15.2-.29.31-.43Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M28.31,87.37c0,.47,0,.94,0,1.4,0,.13-.18.25-.28.37-.08-.12-.23-.24-.23-.36q0-1.36,0-2.73c0-.11.16-.22.25-.33.09.1.25.21.26.32C28.33,86.48,28.31,86.93,28.31,87.37Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M30.34,87.44c0,.46,0,.93,0,1.39,0,.11-.18.21-.28.31-.08-.1-.22-.19-.23-.29,0-1,0-1.91,0-2.86,0-.09.15-.18.24-.27.09.1.25.21.26.32C30.36,86.5,30.34,87,30.34,87.44Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M31.7,85.8c0,1,0,2,0,3,0,.12-.14.24-.22.36-.1-.12-.28-.24-.28-.37q0-1.36,0-2.73c0-.13.2-.26.31-.4Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M33,85.81c0,1,0,2,0,2.92,0,.14-.16.28-.24.41-.1-.13-.27-.25-.27-.38,0-.89,0-1.78,0-2.67,0-.15.21-.29.32-.43Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M34.48,85.64c.1.14.3.27.3.41,0,.91,0,1.82,0,2.73,0,.12-.15.24-.23.36-.09-.12-.27-.24-.27-.37,0-1,0-2,0-3Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M36.16,85.82c0,1,0,2,0,3,0,.11-.15.23-.24.34-.09-.11-.26-.21-.26-.32,0-.93,0-1.86,0-2.79,0-.13.22-.25.33-.38Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M38.19,85.82c0,1,0,2,0,2.92,0,.13-.16.27-.25.4-.09-.13-.25-.26-.26-.39,0-.89,0-1.78,0-2.67,0-.14.2-.28.32-.42Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M39.52,87.42c0,.45,0,.89,0,1.34,0,.13-.17.25-.26.38-.09-.11-.24-.23-.24-.35,0-.9,0-1.82,0-2.72,0-.12.16-.24.24-.35.1.12.26.24.27.37C39.54,86.53,39.52,87,39.52,87.42Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M40.79,87.48c0,.44,0,.89,0,1.33,0,.12-.17.22-.26.33-.09-.11-.25-.22-.25-.34q0-1.39,0-2.79c0-.1.15-.2.23-.29.09.1.27.19.28.3C40.81,86.5,40.79,87,40.79,87.48Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M42.65,87.49c0,.42,0,.84,0,1.26,0,.14-.17.26-.26.39-.09-.11-.25-.23-.25-.34q0-1.36,0-2.73c0-.12.16-.24.24-.35.09.12.26.24.27.37C42.67,86.55,42.65,87,42.65,87.49Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M43.62,85.66c.11.14.33.27.33.41,0,.91,0,1.82,0,2.73,0,.12-.16.23-.25.34-.09-.11-.26-.21-.26-.32,0-1,0-2,0-3Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M45.69,85.65c.1.15.29.3.3.45,0,.89,0,1.78,0,2.67,0,.13-.18.25-.28.37-.08-.12-.22-.24-.23-.36,0-1,0-2,0-3Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M47.36,87.43c0,.47,0,.93,0,1.4,0,.11-.18.21-.27.31-.08-.1-.23-.19-.23-.29,0-.95,0-1.9,0-2.86,0-.09.15-.18.24-.27.09.1.25.2.26.32C47.38,86.5,47.36,87,47.36,87.43Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M48.64,85.81c0,1,0,2,0,3,0,.12-.15.23-.24.35-.09-.12-.27-.25-.27-.37,0-.89,0-1.78,0-2.67,0-.15.2-.3.31-.44Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M50.1,85.66c.12.14.33.27.34.41,0,.91,0,1.82,0,2.73,0,.12-.16.23-.24.34-.09-.11-.26-.21-.26-.32,0-1,0-2,0-3Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M51.82,87.46c0,.45,0,.89,0,1.33,0,.12-.15.24-.24.35-.09-.11-.26-.21-.26-.32q0-1.39,0-2.79c0-.11.17-.21.27-.31.08.11.23.22.23.35C51.83,86.53,51.82,87,51.82,87.46Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M53.85,87.39c0,.46,0,.93,0,1.39,0,.13-.15.24-.23.36-.1-.12-.28-.25-.28-.37q0-1.33,0-2.67c0-.13.17-.26.26-.38.09.13.24.26.25.4C53.87,86.54,53.85,87,53.85,87.39Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M54.82,85.66c.12.14.33.27.34.41,0,.91,0,1.82,0,2.73,0,.11-.16.23-.24.34-.09-.11-.26-.21-.26-.32,0-1,0-2,0-3Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M56.1,85.66c.12.14.33.27.33.41,0,.91,0,1.82,0,2.73,0,.12-.16.23-.25.34-.09-.11-.26-.22-.26-.33,0-1,0-2,0-3Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M58.3,87.45c0,.44,0,.89,0,1.33,0,.12-.15.24-.23.36-.1-.12-.28-.25-.28-.37,0-.91,0-1.82,0-2.73,0-.11.17-.22.26-.32.09.11.24.22.25.33C58.32,86.52,58.3,87,58.3,87.45Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M59.27,85.65c.12.12.33.24.34.37,0,.93,0,1.86,0,2.79,0,.12-.16.22-.25.33-.09-.11-.25-.22-.25-.34,0-1,0-2,0-3Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M61.34,85.65c.11.15.3.3.31.45,0,.89,0,1.78,0,2.66,0,.15-.2.29-.31.44l-.17-.11V85.81Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M63,87.45c0,.45,0,.89,0,1.33,0,.13-.15.24-.23.36-.1-.1-.27-.2-.28-.31q0-1.39,0-2.79c0-.11.17-.22.27-.32.08.11.23.22.24.34C63,86.52,63,87,63,87.45Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M64.3,87.49c0,.43,0,.85,0,1.27,0,.13-.18.26-.28.38-.08-.12-.23-.23-.23-.35q0-1.37,0-2.73c0-.12.15-.23.24-.34.09.12.26.24.27.38C64.32,86.56,64.3,87,64.3,87.49Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M65.61,89.05V85.8c.32-.16.51-.13.51.29,0,.89,0,1.78,0,2.67,0,.15-.2.29-.3.44Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M67.48,87.43c0,.44,0,.89,0,1.33,0,.13-.18.26-.27.38-.09-.12-.24-.23-.24-.35q0-1.37,0-2.73c0-.12.16-.23.24-.34.1.12.26.25.27.38C67.5,86.54,67.48,87,67.48,87.43Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M69.51,87.41c0,.46,0,.93,0,1.39,0,.12-.17.23-.25.34-.1-.11-.26-.22-.27-.33,0-.93,0-1.86,0-2.79,0-.1.18-.2.28-.3.08.1.22.19.23.29C69.52,86.48,69.51,86.94,69.51,87.41Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M70.53,85.64c.1.14.28.28.29.42,0,.91,0,1.82,0,2.73,0,.12-.15.24-.24.35-.09-.1-.26-.21-.26-.31,0-1,0-2,0-3Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M71.78,85.66c.11.14.31.28.31.43q0,1.34,0,2.67c0,.15-.19.29-.3.44l-.17-.1V85.81Z"
              transform="translate(-13.33 -3.36)"
            />
            <path
              d="M74.93,85.66c.12.14.33.27.34.41q0,1.37,0,2.73c0,.14-.19.28-.29.42l-.18-.1V85.78Z"
              transform="translate(-13.33 -3.36)"
            />
          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
